import React from "react";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";

export const DropdownFilterField = ({ group, value, onChange, disabled }) => (
    <div>
        <label className="form-label small fw-bold text-muted text-uppercase" htmlFor={`th-filter-${group.key}`}>{group.name}</label>
        <select
            id={`th-filter-${group.key}`}
            className="form-select form-select-sm border-light-subtle"
            value={value ?? ""}
            onChange={(e) => {
                let val = e.target.value;
                if (val === "true") val = true;
                if (val === "false") val = false;
                onChange(val);
            }}
            disabled={group.disabled || disabled}
        >
            {group.options.map((opt) => (
                <option key={String(opt?.key)} value={opt?.key}>{opt?.name}</option>
            ))}
        </select>
    </div>
);

export const DateFilterField = ({ picker, value, onChange }) => (
    <div className="d-flex flex-column">
        <label className="form-label small fw-bold text-muted text-uppercase">{picker.name}</label>
        <DatePicker
            containerClassName="w-100"
            inputClass="form-control form-control-sm border-light-subtle"
            value={value}
            onChange={(date) => onChange(date?.toDate ? date.toDate() : date)}
            minDate={picker.minStartDate}
            maxDate={picker.minEndDate}
            format="YYYY-MM-DD"
        />
    </div>
);

export const DateRangeFilterField = ({ range, fromValue, toValue, onFromChange, onToChange }) => (
    <div>
        <label className="form-label small fw-bold text-muted text-uppercase">{range.name}</label>
        <div className="row g-2">
            <div className="col-6">
                <DatePicker
                    containerClassName="w-100"
                    inputClass="form-control form-control-sm border-light-subtle"
                    placeholder="From"
                    value={fromValue}
                    onChange={(date) => onFromChange(date?.toDate ? date.toDate() : date)}
                    minDate={range.from?.minStartDate}
                    maxDate={range.from?.minEndDate}
                    format="DD-MM-YYYY"
                />
            </div>
            <div className="col-6">
                <DatePicker
                    containerClassName="w-100"
                    inputClass="form-control form-control-sm border-light-subtle"
                    placeholder="To"
                    value={toValue}
                    onChange={(date) => onToChange(date?.toDate ? date.toDate() : date)}
                    minDate={range.to?.minStartDate}
                    maxDate={range.to?.minEndDate}
                    format="DD-MM-YYYY"
                />
            </div>
        </div>
    </div>
);
